
<template>
  <div class="p-3 dark:bg-blue-dark bg-primary bg-opacity-10 dark:bg-opacity-40 rounded dark:text-white text-black text-opacity-60 grid grid-cols-3 gap-x-2 text-[13px]">
    <div
        class="rounded border-primary border p-2 text-center flex items-center gap-x-2 justify-center cursor-pointer"
        :class="{ 'text-white bg-primary': calcFormStore.selectedCurrency === 'RUB_RUB' }"
        @click="setCurrency('RUB_RUB')"
    >
      <RubIcon />
      RUB
    </div>
    <div
        class="rounded border-primary border p-2 text-center flex items-center gap-x-2 justify-center cursor-pointer"
        :class="{ 'text-white bg-primary': calcFormStore.selectedCurrency === 'KZT_RUB' }"
        @click="setCurrency('KZT_RUB')"
    >
      <KztIcon />
      KZT
    </div>
    <div
        class="rounded border-primary border p-2 text-center flex items-center gap-x-2 justify-center cursor-pointer"
        :class="{ 'text-white bg-primary': calcFormStore.selectedCurrency === 'USD_RUB' }"
        @click="setCurrency('USD_RUB')"
    >
      <UsdIcon />
      USD
    </div>
    <div class="indicator" :style="{ left: indicatorPosition }"></div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useCalcFormStore } from "@/stores/calcFormStore";
import RubIcon from "@/assets/icons/circle-ruble.svg";
import KztIcon from "@/assets/icons/circle-tenge.svg";
import UsdIcon from "@/assets/icons/circle-dollar.svg";

const calcFormStore = useCalcFormStore();

const setCurrency = (currency: string) => {
  calcFormStore.setCurrency(currency);
};

const indicatorPosition = computed(() => {
  return {
    RUB_RUB: "0%",
    KZT_RUB: "33.33%",
    USD_RUB: "66.66%",
  }[calcFormStore.selectedCurrency] || "0%";
});
</script>

<style scoped>

</style>
